import React from 'react';
import Highcharts, { XrangePointOptionsObject } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { chartGradientColors } from '../../core/constants/colors';
import { ChartStorageLevel } from '../../core/models/gas';

export interface IColumnChart {
  title: string | undefined;
  yAxisTitle: string;
  data: ChartStorageLevel[];
}

export default function ColumnChart({ title, yAxisTitle, data }: IColumnChart): JSX.Element {
  const chartData: XrangePointOptionsObject[] = data.map((column) => ({
    type: 'column',
    name: column.name,
    value: column.value,
    y: column.value,
    color: column.color === 'blue' ? chartGradientColors[0] : chartGradientColors[1],
  }));

  const options: Highcharts.Options = {
    chart: {
      type: 'column',
      animation: false,
    },
    credits: {
      enabled: false,
    },

    title: {
      text: undefined,
    },

    tooltip: {
      valueDecimals: 2,
    },

    xAxis: {
      type: 'category',
      labels: {
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif',
        },
      },
    },

    yAxis: {
      title: {
        text: yAxisTitle,
      },
    },

    legend: {
      enabled: false,
    },

    plotOptions: {
      column: {
        groupPadding: 0,
        borderRadius: 4,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}',
        },
      },
      series: {
        animation: false,
      },
    },

    series: [{ name: 'Value', type: 'column', data: [...chartData], minPointLength: 3 }],
  };

  return (
    <div>
      {title === undefined ? null : <h3 className="mb-7 pl-2-8">{title}</h3>}
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
